<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon
             v-on="on"
             @click.stop.prevent=""
      >
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <v-row class="title">
          <v-col cols="12">
            {{ transportador.pessoa.nome }}
            <px-transportador-premium v-if="transportador.contratoAtivo"/>
          </v-col>
        </v-row>
        <div>
          <v-skeleton-loader
            :loading="loading"
            max-width="150"
            type="text"
          >
            <px-show-avaliacao-icon-simple span-class="text--primary"
                                           :avaliacao="pontuacao"/>
            <v-icon class="ml-3 mr-1 mb-1">mdi-calculator</v-icon>
            <px-transportador-score :score="score"/>
          </v-skeleton-loader>
        </div>

        <v-row class="">
          <v-col cols="12">
            <v-icon>mdi-domain</v-icon>
            {{ transportador.pessoa.cnpj | cnpj }}
            <px-regime-tributario :regime-tributario="transportador.pessoa.regimeTributario"/>
          </v-col>
        </v-row>
        <v-row class="">
          <v-col cols="12">
            <v-icon>mdi-domain</v-icon>
            {{ transportador.pessoa.email }}
          </v-col>
        </v-row>
        <v-row v-if="transportador.pessoa.telefone">
          <v-col cols="12">
            <v-icon>mdi-phone</v-icon>
            {{ transportador.pessoa.telefone | phone }}
          </v-col>
        </v-row>
        <v-row v-if="transportador.site">
          <v-col cols="12">
            <v-icon>mdi-web</v-icon>
            {{ site }}
            <v-btn icon :href="site" target="_blank">
              <v-icon small>
                mdi-open-in-new
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="">
          <v-col cols="12">
            <v-icon>mdi-map-marker</v-icon>
            {{ transportador.endereco | endereco }}
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import TransportadorService from './transportador-service';

export default {
  props: {
    icon: {
      type: String,
      default: 'mdi-chevron-down',
    },
    transportador: Object,
  },
  data: () => ({
    menuOpened: false,
    loading: false,
    loadingDetalhes: false,
    score: null,
  }),
  computed: {
    site() {
      if (!this.transportador.site) {
        return null;
      }
      if (this.transportador.site.includes('http://') || this.transportador.site.includes('https://')) {
        return this.transportador.site;
      }
      return `https://${this.transportador.site}`;
    },
    pontuacao() {
      if (!this.score) {
        return null;
      }
      return this.score.pontuacaoMedia;
    },
  },
  methods: {
    getScore() {
      this.loading = true;
      TransportadorService.getScore(this.transportador.id)
        .then(({ data }) => {
          this.score = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    menuOpened(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (this.menuOpened) {
        this.getScore();
      }
    },
  },
};
</script>
